// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardContainer_cardContainer__hFr0d {
  border: 1px solid lightgray;
  border-radius: 4px;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  max-height: 9rem;
}

.CardContainer_clickable__99Dg- {
  cursor: pointer;
}
.CardContainer_clickable__99Dg-:hover {
  background-color: lightgrey;
}`, "",{"version":3,"sources":["webpack://./src/components/ReportConfigurator/CardContainer.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;AACF;AACE;EACE,2BAAA;AACJ","sourcesContent":[".cardContainer {\n  border: 1px solid lightgray;\n  border-radius: 4px;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  max-height: 9rem;\n}\n\n.clickable {\n  cursor: pointer;\n}\n.clickable:hover {\n  background-color: lightgrey;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `CardContainer_cardContainer__hFr0d`,
	"clickable": `CardContainer_clickable__99Dg-`
};
export default ___CSS_LOADER_EXPORT___;
